import { type HttpClientConfig, type HttpClientInterface } from 'core/infra/http/HttpClient'

type RateconDependencies = {
  httpClient: HttpClientInterface
}

export class RateconRepository {
  private httpClient: HttpClientInterface

  constructor({ httpClient }: RateconDependencies) {
    this.httpClient = httpClient
  }

  async getRatecon(refNumber: string, config?: Partial<HttpClientConfig>): Promise<string> {
    const endpoint = `/api/v2/shipments/${refNumber}/rate_confirmation`
    const { data } = await this.httpClient.get<any>(endpoint, {
      ...config,
      responseType: 'blob',
    })
    const fileURL = URL.createObjectURL(data)
    return fileURL
  }
}
